import React from "react";

import { useAuth } from "contexts/AuthProvider";
import PrimaryButton from "components/PrimaryButton";

const LoginRedirect = (): React.ReactElement => {
  const auth = useAuth();

  React.useEffect(() => {
    auth.login();
  }, [auth]);

  return <PrimaryButton onClick={auth.login}>Login</PrimaryButton>;
};

export default LoginRedirect;
